import WelcomeComp from "pages/Dashboard/WelcomeComp"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap"
import React from "react"

const LoginDashboard = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="text-primary p-3">
          <h5 className="text-primary">Welcome Back !</h5>
        </div>
      </div>
    </React.Fragment>
  )
}

export default LoginDashboard
